import React, { useContext, useState } from "react";
import LoadingAction from "../../../../themes/LoadingAction/LoadingAction";
import "./EditCliente.css";
import { Button, Input, DatePicker, Tooltip } from "antd";
import { AuthContext } from "../../../../contexts/AuthContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import * as links from "../../../../utils/links";
import axios from "axios";
import question_icon from "../../../../assets/images/question.png";
import moment from "moment";

const EditCliente = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const cliente = location.state || {};

  const { authInfo, setNotiMessage, setDataUser } = useContext(AuthContext);
  const { dataUser } = authInfo;
  const token = authInfo?.dataUser?.token;
  const dateFormat = "YYYY-MM-DD";

  const dataInicial = cliente?.dataVencimento
    ? moment(cliente.dataVencimento)
    : moment().add(1, "years");

  const [data, setData] = useState({
    nome: cliente?.nome ?? "",
    mercadoPagoToken: cliente?.mercadoPagoToken ?? "",
    dataVencimento: dataInicial.isValid() ? dataInicial : moment().add(1, "years"),
    pagbankToken: cliente?.pagbankToken ?? "",
    pagbankEmail: cliente?.pagbankEmail ?? "",
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [newPassword, setNewPassword] = useState("");

  const handleChange = (name, value) => {
    setData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => {
      const next = { ...prev };
      delete next[name];
      return next;
    });
  };

  const valorMudou = (novoValor, valorOriginal) =>
    String(novoValor ?? "") !== String(valorOriginal ?? "");

  const onSave = () => {
    const errorsTemp = {};
    const nome = String(data.nome ?? "").trim();
    const dataSelecionada = moment.isMoment(data.dataVencimento)
      ? data.dataVencimento
      : moment(data.dataVencimento, dateFormat, true);

    if (!nome) errorsTemp.nome = "Este campo é obrigatório";
    if (!dataSelecionada?.isValid()) {
      errorsTemp.dataVencimento = "Selecione uma data válida";
    }

    if (Object.keys(errorsTemp).length > 0) {
      setErrors(errorsTemp);
      return;
    }

    const body = {
      nome,
      dataVencimento: dataSelecionada.clone().startOf("day").toISOString(),
    };

    if (valorMudou(data.mercadoPagoToken, cliente?.mercadoPagoToken)) {
      body.mercadoPagoToken = data.mercadoPagoToken;
    }

    if (valorMudou(data.pagbankToken, cliente?.pagbankToken)) {
      body.pagbankToken = data.pagbankToken;
    }

    if (valorMudou(data.pagbankEmail, cliente?.pagbankEmail)) {
      body.pagbankEmail = data.pagbankEmail;
    }

    setIsLoading(true);
    axios
      .put(
        `${process.env.REACT_APP_SERVIDOR}/alterar-cliente-adm-new/${cliente.id || id}`,
        body,
        {
          headers: {
            "x-access-token": token,
            "content-type": "application/json",
          },
        }
      )
      .then(() => {
        setIsLoading(false);
        setNotiMessage({
          type: "success",
          message: "Cliente atualizado com sucesso.",
        });
        navigate(links.DASHBOARD_CLIENTES);
      })
      .catch((err) => {
        setIsLoading(false);
        const status = err.response?.status;
        const detalhe = err.response?.data?.error || err.response?.data?.message;

        if ([401, 403].includes(status)) {
          setNotiMessage({
            type: "error",
            message: "A sua sessão expirou, para continuar faça login novamente.",
          });
          if (dataUser?.key === "ADMIN") {
            navigate(links.ADMIN_SIGNIN);
          } else {
            navigate(links.SIGNIN);
          }
          setDataUser(null);
          return;
        }

        setNotiMessage({
          type: "error",
          message: detalhe || "Não foi possível salvar as alterações do cliente.",
        });
      });
  };

  const onNewPassword = () => {
    setIsLoading(true);
    axios
      .put(
        `${process.env.REACT_APP_SERVIDOR}/cliente-trocar-senha`,
        { email: cliente?.email },
        {
          headers: {
            "x-access-token": token,
            "content-type": "application/json",
          },
        }
      )
      .then((res) => {
        setIsLoading(false);
        setNewPassword(res?.data?.newPassword || "");
      })
      .catch((err) => {
        setIsLoading(false);
        setNotiMessage({
          type: "error",
          message: err.response?.data?.error || "Não foi possível resetar a senha.",
        });
      });
  };

  return (
    <div className="Edit_Cliente_container">
      {isLoading && <LoadingAction />}

      <div className="Edit_Cliente_header">
        <div className="Edit_Cliente_header_left">
          <div className="Edit_Cliente_staBlockTitle">Editar Cliente</div>
        </div>
        <Button
          className="Edit_Cliente_header_back"
          onClick={() =>
            navigate(`${links.CLIENTES_MAQUINAS}/${id}`, { state: cliente })
          }
        >
          <span>VOLTAR</span>
        </Button>
      </div>

      <div className="Edit_Cliente_content">
        <div className="Edit_Cliente_itemField">
          <label className="Edit_Cliente_itemFieldLabel">Email: {cliente?.email}</label>
        </div>

        <div className="Edit_Cliente_itemField">
          <label className="Edit_Cliente_itemFieldLabel" htmlFor="nome">Nome:</label>
          <Input
            placeholder="Jukinha da Silva"
            value={data.nome}
            id="nome"
            name="nome"
            autoComplete="nome"
            onChange={(event) => handleChange("nome", event.target.value)}
            className={errors.nome ? "Edit_Cliente_inputError" : ""}
          />
          {errors.nome && <div className="Edit_Cliente_itemFieldError">{errors.nome}</div>}
        </div>

        <div className="Edit_Cliente_itemFieldMercadoPago">
          <div className="Edit_Cliente_Label_Icon">
            <label className="Edit_Cliente_itemFieldLabel" htmlFor="mercadoPagoToken">
              Token Mercado Pago
            </label>
            <img
              src={question_icon}
              alt="Ajuda"
              className="Edit_Cliente_Icon"
              onClick={() =>
                navigate(links.TOKEN_HELP_PAGE, {
                  state: { redirect_url: `${links.EDITAR_CLIENTES}/${cliente.id}` },
                })
              }
            />
          </div>
          <Input
            placeholder="APPMP123123-12312-123123"
            value={data.mercadoPagoToken}
            id="mercadoPagoToken"
            name="mercadoPagoToken"
            autoComplete="mercadoPagoToken"
            onChange={(event) => handleChange("mercadoPagoToken", event.target.value)}
            className={errors.mercadoPagoToken ? "Edit_Cliente_inputError" : ""}
          />
        </div>

        <div className="Edit_Cliente_itemFieldPagbank">
          <div className="AddCliente_Label_Icon">
            <label className="Edit_Cliente_itemFieldLabel" htmlFor="pagbankToken">
              Token Pagbank
            </label>
            <Tooltip
              title={
                <>
                  Acesse o PagBank, entre na conta, vá em Vendas, Plataformas e Checkout,
                  Integrações e escolha Gerar token.
                </>
              }
            >
              <img src={question_icon} alt="Ajuda" className="AddCliente_Icon" />
            </Tooltip>
          </div>
          <Input
            placeholder="Token do PagBank"
            value={data.pagbankToken}
            id="pagbankToken"
            name="pagbankToken"
            autoComplete="pagbankToken"
            onChange={(event) => handleChange("pagbankToken", event.target.value)}
            className={errors.pagbankToken ? "Edit_Cliente_inputError" : ""}
          />
        </div>

        <div className="Edit_Cliente_itemFieldPagbank">
          <label className="Edit_Cliente_itemFieldLabel" htmlFor="pagbankEmail">Email Pagbank</label>
          <Input
            placeholder="email@pagbank.com"
            value={data.pagbankEmail}
            id="pagbankEmail"
            type="email"
            name="pagbankEmail"
            autoComplete="pagbankEmail"
            onChange={(event) => handleChange("pagbankEmail", event.target.value)}
            className={errors.pagbankEmail ? "Edit_Cliente_inputError" : ""}
          />
        </div>

        <div className="Edit_Cliente_itemField">
          <div className="AddCliente_Label_Icon">
            <label className="Edit_Cliente_itemFieldLabel" htmlFor="dataVencimento">
              Data de Vencimento
            </label>
            <Tooltip title="Após o vencimento existe a regra de bloqueio das máquinas. Para cliente que não paga mensalidade, escolha uma data futura maior.">
              <img src={question_icon} alt="Ajuda" className="AddCliente_Icon" />
            </Tooltip>
          </div>
          <DatePicker
            value={data.dataVencimento}
            format={dateFormat}
            id="dataVencimento"
            name="dataVencimento"
            autoComplete="dataVencimento"
            onChange={(valor) => handleChange("dataVencimento", valor)}
            className={errors.dataVencimento ? "AddCliente_inputError" : ""}
          />
          {errors.dataVencimento && (
            <div className="AddCliente_itemFieldError">{errors.dataVencimento}</div>
          )}
        </div>

        <Button className="Edit_Cliente_saveBtn" onClick={onSave} disabled={isLoading}>
          SALVAR ALTERAÇÕES
        </Button>

        <Button
          className="Edit_Cliente_deleteBtn"
          onClick={() => navigate(`${links.DELETE_CLIENTE}/${id}`, { state: cliente })}
          disabled={isLoading}
        >
          EXCLUIR CLIENTE
        </Button>

        <Button className="Edit_Cliente_ResetBtn" onClick={onNewPassword} disabled={isLoading}>
          <div className="Edit_Cliente_Reset_Icon_Title">
            <span>RESETAR SENHA</span>
          </div>
        </Button>

        <div style={{ marginTop: "10px" }}>{newPassword}</div>
      </div>
    </div>
  );
};

export default EditCliente;
